export const BULK_ACTIONS_PANEL_CONFIG = {
  /** Below this many actions the list is short enough to scan without a search box. */
  searchMinItems: 6,
} as const;
